import { fromJS } from 'immutable'

export default fromJS({
  questions: {
    noAlt: 'Відсутній альтернативний текст для цього зображення',
    noAnswers: "Немає варіанту відповіді, будь ласка, натисніть на 'Наступне', щоб продовжити",
    placeholder: 'Введіть Вашу відповідь...',
    pleaseSelect: 'Оберіть варіант...',
    rotateLandscape: 'Вимкніть блокування орієнтації на телефоні та поверніть його в альбомну орієнтацію.',
    rotatePortrait: 'Поверніть телефон з альбомної орієнтації на портретну.',
    ir: {
      selectWebCam: "Оберіть вебкамеру (якщо така доступна) або натисніть 'Пошук', щоб завантажити з пристрою",
      noWebCam: 'Не знайдено вебкамери',
      accessCamUpload: 'ДОСТУП ДО КАМЕРИ/ЗАВАНТАЖЕННЯ',
      browse: 'ПОШУК',
      uploadPhoto: 'Завантажити фото',
      instead: 'натомість',
      startOver: 'ПОЧАТИ НАНОВО',
      capture: 'ФОТО',
      allDone: 'ГОТОВО!',
      somethingWrong: 'Вибачте, сталась помилка. Будь ласка, спробуйте знову пізніше',
      couldntRead: 'Вибачте, ми не змогли прочитати код!',
      couldntProcess: 'Вибачте, ми не змогли опрацювати зображення!',
      moveOn: 'Будь ласка, спробуйте знову або завантажте своє фото та продовжіть процес',
      tryAgain: 'Будь ласка, спробуйте знову',
      dataReceived: 'Дані отримано!',
      enterManually: 'Будь ласка, спробуйте знову або введіть дані вручну нижче',
      positionQR:
        "Будь ласка, наведіть свою камеру на QR код, щоб він помістився у червону рамку, або завантажте фото QR коду з комп'ютера.",
      submit: 'ВІДПРАВИТИ',
      analyzing: 'Аналіз зображення, будь ласка, зачекайте',
      cantAnalyze:
        'Увага - не вдалося відтворити це зображення. Будь ласка, спробуйте перезавантажити або оберіть універсальний формат зображень (JPG, PNG, GIF, BMP)',
      wrongFormat:
        'Вибачте, цей формат файлів не підтримується. Будь ласка, завантажте зображення у форматі, що підтримується (JPG, PNG, GIF, BMP, TIF, PDF, SVG)'
    },
    vr: {
      noWebCam: 'Не знайдено вебкамери',
      uploadVideo: 'Завантажити відео',
      skip: 'Пропустити?',
      accessCamUpload: 'ДОСТУП ДО КАМЕРИ/ЗАВАНТАЖЕННЯ',
      browse: 'ПОШУК',
      instead: 'натомість',
      or: 'або',
      stopRecording: 'Зупинити запис',
      willBeStopped: 'Запис зупиниться на 5-й хвилині',
      stopOnDone: 'Зупиніть запис, коли закінчите!',
      record: 'ЗАПИС',
      somethingWrong: 'Вибачте, сталась помилка. Будь ласка, спробуйте знову пізніше',
      microphone: 'Мікрофон',
      camera: 'Веб-камера',
      selectMicrophone: 'Оберіть мікрофон',
      selectCam: 'Оберіть веб-камеру',
      submit: 'ВІДПРАВИТИ',
      upload: 'Завантажити',
      playback: 'Відтворення',
      stopPlayback: 'ЗАСТАНОВИТИ',
      startOver: 'ПОЧАТИ НАНОВО',
      allDone: 'ГОТОВО!',
      alternativeRecordSpan:
        "Будь ласка, завантажте відеоролик з вашого комп'ютеру або іншого пристрою.<br/>Також ви можете  &nbsp;",
      alrenativeRecordHref: 'записати відео на веб-камеру.',
      cantAnalyze:
        'Увага - нам не вдалося відтворити це відео. Будь ласка, спробуйте перезавантажити або оберіть універсальний формат відео (MP4, M4V, WEBPM)',
      wrongFormat:
        'Вибачте, цей формат файлів не підтримується. Будь ласка, завантажте відео у форматі, що підтримується (MP4, AVI, M4V, WEBPM, MOV, MKV, MPG, WMV)'
    },
    cjc: {
      choose: 'ВИБРАТИ',
      pleaseChoose: 'Будь ласка, оберіть',
      this: 'ЦЕЙ',
      one: 'щось одне',
      myChoice: 'Мій ВИБІР'
    },
    hm: {
      addComment: 'Будь ласка, додайте коментар нижче',
      commentMandatoryPlaceHolder: "Будь ласка, додайте обов'язковий коментар…",
      commentOptionalPlaceHolder: "Будь ласка, додайте необов'язковий коментар… ",
      dragPin: 'Перетягніть, щоб змінити положення (натисніть/торкніться та потримайте, щоб закріпити точно).',
      removePin: 'Перетягніть за межі зображення, щоб видалити.',
      editComment: 'Натисніть/торкніться пiн, щоб відредагувати коментар.',
      addPin: 'Будь ласка, перетягніть пiн з панелі нижче та відпустіть її на обраному місці на зображенні.',
      addPins: 'Будь ласка, перетягніть пiни з панелі нижче та відпустіть їх на обраному місці на зображенні.',
      leavePins: (minPoints, maxPoints) =>
        `Будь ласка, залиште принаймнi ${minPoints}, але не більше ${maxPoints} пiнiв кожного виду.`,
      leavePinsPerPage: (minPoints, maxPoints) =>
        `Будь ласка, залиште принаймнi ${minPoints}, але не більше ${maxPoints} пiнiв.`,
      leavePinsWithOff: maxPoints =>
        `Будь ласка, залиште не більше ${maxPoints} пiнiв кожного виду або натисніть Далі, щоб пропустити.`,
      leavePinsPerPageWithOff: maxPoints =>
        `Будь ласка, залиште не більше  ${maxPoints} пiнiв або натисніть Далі, щоб пропустити.`,
      leavePinWithOff: 'Будь ласка, залиште не більше 1 пiнa кожного виду або натисніть Далі, щоб пропустити.',
      leavePinPerPageWithOff: 'Будь ласка, залиште не більше 1 пiнa або натисніть Далі, щоб пропустити.',
      leaveExactlyPin: 'Будь ласка, залиште по одному пiну кожного виду.',
      leaveExactlyPinPerPage: 'Будь ласка, залиште один пiн.',
      leaveExactlyPins: maxPoints =>
        `Будь ласка, залиште ${maxPoints} пiн${maxPoints >= 2 ? (maxPoints < 5 ? 'а' : 'iв') : ''} кожного виду.`,
      leaveExactlyPinsPerPage: maxPoints =>
        `Будь ласка, залиште ${maxPoints} пiн${maxPoints >= 2 ? (maxPoints < 5 ? 'а' : 'iв') : ''}.`,
      leaveComment: 'Введіть текст під зображенням, щоб залишити коментар.',
      noAnswers: 'Немає варіанту відповіді. Будь ласка, натисніть далі, щоб продовжити.',
      outOfPins: 'У вас закінчилися пiни',
      pinsBehavior: 'Під час переміщення по зображенню ви побачите області, які буде виділено  коли в них стоїть пін.',
      clusters: 'Ви зможете розміщувати шпильки лише в цих виділених областях.',
      contentAware: 'Ви можете розміщувати шпильки всередині або поза межами виділених областей.'
    },
    mp: {
      expand_note: 'Будь ласка, наведіть курсор миші або натисніть на зображення, щоб розгорнути',
      rb_note: rows => `Оберіть лише 1 відповідь на кожне з наведених ${rows ? ' нижче' : ''} запитань:`,
      cb_note: (min, max, rows) => {
        if (1 === min && 5000 === max) {
          return 'Виберіть всі відповідні варіанти:'
        } else if (min === max) {
          return `Оберіть будь-яку ${min} відповід${min < 5 ? 'і' : 'ей'} на кожне з наведених ${
            rows ? ' нижче' : ''
          } запитань:`
        } else if (min > 0 && max < 5000) {
          return `Будь ласка, виберіть принаймні ${min} відповід${
            1 == min ? 'ь' : min < 5 ? 'і' : 'ей'
          }, але не більше ${max} для кожного пункту ${rows ? ' нижче' : ''}:`
        } else if (5000 === max && min > 0) {
          return `Будь ласка, виберіть принаймні ${min} відповід${
            max >= 2 ? (min < 5 ? 'і' : 'ей') : 'ь'
          } для кожного пункту ${rows ? ' нижче' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Будь ласка, виберіть не більше ${max} відповід${1 == min ? 'і' : 'ей'} для кожного пункту${
            rows ? ' нижче' : ''
          }:`
        } else {
          return 'Виберіть всі відповідні варіанти:'
        }
      }
    },
    sh: {
      note: 'Клікніть на продукт, щоб збільшити його та додати у свій віртуальний кошик, якщо ви купили б його в магазині',
      amazonNote: 'Натисніть на товар, щоб збільшити його та додати у свій віртуальний кошик.',
      fullCart: 'Ваш кошик заповнений!',
      qty: 'КІЛЬКІСТЬ',
      each: 'кожен',
      items: 'ел',
      addToCart: 'ДОДАТИ У КОШИК',
      deleteFromCart: 'ВИДАЛИТИ',
      emptyCard: 'Ваш кошик порожній',
      total: 'Кошик',
      clearCart: 'Очистити кошик',
      backToStore: 'Повернутись до магазину',
      next: 'ДАЛІ',
      na: 'Жоден із варіантів',
      maxCartCountError: max => `Будь ласка, додайте до свого кошика не більше ${max} товарів.`,
      scrollError: `Будь ласка, прокрутіть повністю ліворуч і праворуч, щоб продовжити опитування. `,
      maxSpentError: max => `Будь ласка, витратьте не більше ${max}.`,
      maxProductCountError: max => `Будь ласка, додайте не більше ніж кількість ${max} до кошика для кожного товару.`
    },
    rb: {
      note: 'Виберіть 1 варiант:'
    },
    vo: {
      note: 'Будь ласка, перегляньте відео до кінця'
    },
    cb: {
      note: (min, max) => {
        if (min === max) {
          return `Виберіть ${min} чекбокс${min >= 3 ? (min < 3 ? 'а' : 'ів') : 'a'}:`
        } else if (min > 0 && max < 5000) {
          return `Виберіть от ${min} до ${max} чекбокс${max >= 3 ? (max < 3 ? 'а' : 'ів') : 'a'}:`
        } else if (5000 === max && min > 0) {
          return `Виберіть не менше ${min} чекбокс${min >= 3 ? (min < 3 ? 'а' : 'ів') : 'a'}:`
        } else if (0 === min && max < 5000) {
          return `Виберіть не більше ${max} чекбокс${max >= 3 ? (max < 3 ? 'а' : 'ів') : 'a'}:`
        } else {
          return 'Виберіть всі підходящі варіанти:'
        }
      }
    },
    oe: {
      na: 'Не застосовується',
      note: (min, max, optional) => {
        if (min === max) {
          return `Введіть ${min} символ${1 !== min && min <= 4 ? 'а' : ''}${min > 4 ? 'iв' : ''}${
            optional ? " (необов'язкове поле)" : ''
          }:`
        } else if (min > 0 && max < 5000) {
          return `Введіть от ${min} до ${max} символ${1 === max ? 'а' : 'iв'}${
            optional ? " (необов'язкове поле)" : ''
          }:`
        } else if (5000 === max && min > 0) {
          return `Введіть не менше ${min} символ${1 === min ? 'а' : 'iв'}${optional ? " (необов'язкове поле)" : ''}:`
        } else if (0 === min && max < 5000) {
          return `Введіть не більше ${max} символ${1 === max ? 'а' : 'iв'}${optional ? " (необов'язкове поле)" : ''}::`
        } else {
          return ''
        }
      }
    },
    oex: {
      note: 'Будь ласка, заповніть наступні поля:'
    },
    mx: {
      note: 'Перемістіть виділені слайдери, щоб продовжити',
      dragSlider: 'Пересуньте слайдер вліво або вправо'
    },
    psc: {
      dragLeftRight: 'Пересуньте слайдер вліво або вправо'
    },
    ps: {
      note: value => `Будь ласка, розподіліть бали, що залишилися ${value} між наведеними нижче рядками`,
      allDone: 'ГОТОВО!',
      total: `Всього:`,
      dragSlider: 'Пересуньте слайдер вліво або вправо'
    },
    cx: {
      note: 'Клікніть по комбобоксу і почніть друкувати Вашу відповідь або виберіть його зі списку'
    },
    ro: {
      note: 'Перетягніть вгору або вниз, щоб змінити порядок:'
    },
    md: {
      note1:
        'Будь ласка, натисніть/торкніться елемента, який вам сподобався найбільше<br/>Натисніть/торкніться знову, щоб очистити вибір.',
      note2:
        'Тепер, будь ласка, натисніть/торкніться елемента, який вам сподобався найменше<br/>Натисніть/торкніться знову, щоб очистити вибір.',
      note3:
        'Дякуємо! Перейдіть до наступного запитання<br/>або натисніть/торкніться будь-якого невибраного елемента, щоб почати знову.'
    },
    aro: {
      note: 'Будь ласка, оберіть один варіант з кожної пари:'
    },
    wd: {
      note: 'Переконайтеся, що кожне наступне значення є більшим за попереднє.'
    },
    emd: {
      note: 'Будь ласка, перегляньте відео до кінця',
      noAnswers: "Немає варіанту відповіді, будь ласка, натисніть на 'Наступне', щоб продовжити",
      start: 'Клікніть та утримуйте, щоб почати',
      resume: 'Клікніть та утримуйте, щоб продовжити',
      continue: 'Ви готові! <br /> Натисніть <strong>Далі</strong>, щоб продовжити',
      continueMobile: 'Усе готово! <br /> Натисніть ТУТ, щоб продовжити',
      training: {
        session: 'Тренінг',
        note: 'Будь ласка, завершіть тренування',
        moveLeft: 'Перетягніть диск ліворуч',
        moveBottom: 'Перетягніть диск донизу',
        moveRight: 'Тепер, перетягніть диск праворуч',
        moveTop: 'Тепер, перетягніть диск догори',
        success: 'Чудова робота!'
      }
    },
    sft: {
      noAnswers: "Немає варіанту відповіді, будь ласка, натисніть на 'Наступне', щоб продовжити",
      note: 'Будь ласка, відповідайте якомога швидше та обирайте відповідь, яка інтуїтивно здається вірною',
      finish: 'Ви готові! <br /> Натисніть Далі, щоб продовжити',
      training: {
        start:
          '<p>У цьому пункті вам будуть швидко показані різні слова. Ви повинні бути максимально сконцентровані. ' +
          'Ви повинні реагувати швидко, щоб відповісти.</p> <p>Готові тренуватися?</p>',
        step1: (touch, mouse, key) =>
          touch
            ? `Натисніть "{buttonLeft}"`
            : (mouse ? `Клікніть "{buttonLeft}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Натисніть кнопку "{keyBtnLeft}"` : ''),
        step2: (touch, mouse, key) =>
          touch
            ? `Натисніть "{buttonRight}"`
            : (mouse ? `Клікніть "{buttonRight}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Натисніть кнопку "{keyBtnRight}"` : ''),
        fail: () => 'Занадто повільно',
        success: () => 'Чудово!',
        finish: () =>
          '<p><strong> Відмінно!</strong></p><p>Будь ласка, переконайтесь, <br />' +
          'що протягом наступних 2-3 хвилин <br/> ви не будете відволікатися</p><p>Натисніть Далі щойно будете готові. </p>'
      },
      buttons: {
        start: 'Розпочати',
        yesno: {
          left: 'Так',
          right: 'Ні'
        },
        matches: {
          left: 'Правильно',
          right: 'Неправильно'
        },
        fits: {
          left: 'Підходить',
          right: 'Не підходить'
        },
        thumbs: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        }
      }
    }
  }
})
